import { getCustomerStateApplicant } from '@helpers/CustomerState/getCustomerStateApplicant';
import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useGetDeliveryAddressData = () => {
    const stateKey = useStateKey();

    const { data: customer_state } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey }),
        suspense: true
    });

    if (!customer_state) {
        throw new Error();
    }

    const applicant = getCustomerStateApplicant(customer_state.data);
    const residential_addresses = applicant?.residential_addresses;
    //use latest address based on date_from
    const residential_address = residential_addresses?.sort(
        (a, b) =>
            new Date(b.date_from || 0).getTime() -
            new Date(a.date_from || 0).getTime()
    )[0];

    return {
        residential_address
    };
};
